import * as React from "react";

import { cn } from "@/lib/utils";
import { FORM_TEXTAREA_CLASS_NAME } from "@/components/Forms/form-control-styles";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex w-full border disabled:cursor-not-allowed",
        FORM_TEXTAREA_CLASS_NAME,
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
